export default {
  title: 'Good news - your client is eligible!',
  subtitle: 'Your client must be a director of the business.',
  paragraph: 'Fill out our 5 minute form and you’ll get an instant decision.'
};
